// ─── Angular Imports ───────────────────────────────────────────────────────────
import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';

// ─── Angular Material Imports ─────────────────────────────────────────────────
import { MatDialog } from '@angular/material/dialog';

// ─── Application Imports ───────────────────────────────────────────────────────
import { IProduct } from 'src/app/models/products/product';
import { IPreference } from 'src/app/models/users/userProfile';
import { AuthService } from 'src/app/services/auth.service';
import { ProductsService } from 'src/app/services/products.service';

@Component({
    selector: 'app-dashboard-card',
    templateUrl: './dashboard-card.component.html',
    styleUrls: ['./dashboard-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false
})
export class DashboardCardComponent implements OnInit {
  // ─── Inputs & Outputs ────────────────────────────────────────────────────────
  @Input() data!: IProduct;
  @Input() latestAction: string | null = null;
  @Output() reload = new EventEmitter();

  // ─── State ───────────────────────────────────────────────────────────────────
  isImageLoaded = false;
  currentConfigDate!: IPreference;

  // ─── Constructor ─────────────────────────────────────────────────────────────
  constructor(
    private router: Router,
    public dialog: MatDialog,
    private authService: AuthService,
  ) {}

  // ─── Lifecycle Hooks ────────────────────────────────────────────────────────
  ngOnInit(): void {
    this.authService.currentPreference.subscribe((res) => {
      this.currentConfigDate = res;
    });
  }

  // ─── Action Methods ─────────────────────────────────────────────────────────
  loadImage(): void {
    this.isImageLoaded = true;
  }

  onEdit(): void {
    this.router.navigateByUrl(`batches/${this.data.batchId}/products/${this.data.id}`);
  }

  getLinkImage(): string {
    return ProductsService.getLinkImage(this.data.thumbnailUri!);
  }
}
